export default __webpack_public_path__ + "static/media/Physics_OrbitalMechanics_2021.5ae2e231.pdf";